// @flow
import JQueryView, { on } from '../common/JQueryView';

export default class BundleView extends JQueryView {
  constructor() {
    super('body');
    const e = window.innerWidth;

    $(window).scroll(function() {
      $(window).scrollTop() > 0
        ? $('.l-header').addClass('is-fixed')
        : $('.l-header').removeClass('is-fixed');
    });

    $(() => {
      const s = $('.overlay'),
        o = $('.l-footer'),
        i = $('.l-header'),
        a = $('.dropdownToggle'),
        n = $('body');
      function t() {
        e > 1059 &&
          (a
            .removeClass('is-active')
            .next('.dropdownMenu')
            .stop()
            .slideUp(200),
          i.removeClass('is-dropdownMenu-show'),
          s.removeClass('is-active'),
          o.removeClass('is-active'),
          n.removeClass('is-fixed'));
      }
      a.on('click', function() {
        const e = $(this);
        e.hasClass('is-active') || t();
        e.toggleClass('is-active')
          .next('.dropdownMenu')
          .stop()
          .slideToggle(200);
        i.toggleClass('is-dropdownMenu-show');
        s.toggleClass('is-active');
        o.toggleClass('is-active');
        n.toggleClass('is-fixed');
      });

      $(document).on('click touchend', function(e) {
        $(e.target).closest('.overlay.is-active').length && t();
      });
    });
    $(() => {
      $('.dropdownMenu__item').each(function() {
        $(this).on('click', function() {
          const e = $(this).attr('href'),
            s = $(this).attr('target');
          return (
            $('.headerNavCloseTrigger').removeClass('is-open'),
            $('.headerNav').removeClass('is-show'),
            $('body').removeClass('is-fixed'),
            $('.overlay').removeClass('is-active'),
            $('.dropdownMenu').hide(),
            $('.dropdownToggle').removeClass('is-active'),
            '_blank' === s
              ? window.open(e, '_blank')
              : (window.location.href = e),
            !1
          );
        });
      });
    });
  }

  @on('click .headerNavTrigger')
  onClickHeaderNavTrigger() {
    return (
      $(this).addClass('is-open'),
      $('.headerNav').addClass('is-show'),
      $('body').addClass('is-fixed'),
      !1
    );
  }

  @on('click .headerNavCloseTrigger')
  onClickHeaderNavCloseTrigger() {
    return (
      $('.headerNavCloseTrigger').removeClass('is-open'),
      $('.headerNav').removeClass('is-show'),
      $('body').removeClass('is-fixed'),
      $('.overlay').removeClass('is-active'),
      $('.dropdownMenu').hide(),
      $('.dropdownToggle').removeClass('is-active'),
      !1
    );
  }
}
